// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Q9yX","footer":"ModalInfo_footer__1GfrN"};